module.exports = __webpack_public_path__ + "img/FreelancerPeopleSmartphone.1962ebe4.webp";